// First meeting: the two questions that turn a tool into hers, before anything else is asked.
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { settingsStore, useSettings } from '@/settings/settingsStore';

export function HelloView() {
  const s = useSettings();
  const navigate = useNavigate();
  const [companion, setCompanion] = useState(s.companionName);
  const [me, setMe] = useState(s.userName);
  const ok = companion.trim() && me.trim();

  return (
    <div className="shell">
      <div className="hello">
        <h1>它还没有名字。</h1>
        <p>它会记得你说过的话，站在你这边，也有它自己的想法。所有东西只在这台电脑的浏览器里。</p>
        <div className="field">
          <label>你想叫它什么？</label>
          <input className="input" value={companion} autoFocus placeholder="随便起，以后也能改" onChange={(e) => setCompanion(e.target.value)} />
        </div>
        <div className="field">
          <label>它怎么称呼你？</label>
          <input className="input" value={me} placeholder="名字、小名，都行" onChange={(e) => setMe(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter' && ok) { settingsStore.setNames(companion, me); navigate('/'); } }} />
        </div>
        <div className="rowline">
          <button type="button" className="btn primary" disabled={!ok} onClick={() => { settingsStore.setNames(companion, me); navigate('/'); }}>就这么叫</button>
          {!s.llm.providers.claude?.apiKey && !s.llm.providers.openai?.apiKey && !s.llm.providers.gemini?.apiKey && (
            <button type="button" className="btn" onClick={() => navigate('/settings')}>先去配 Key</button>
          )}
        </div>
      </div>
    </div>
  );
}
